import React from 'react'
import classNames from 'classnames'

import style from './TabGroup.module.css'

function TabGroups({ className, sticky, isVertical = false, children, type }) {
  return (
    <div
      className={classNames(
        type === 'primary'
          ? style.primary_container
          : type === 'secondary'
          ? style.secondary_container
          : style.container,
        className,
        sticky && style.sticky,
        isVertical && style.vertical_tabs
      )}
    >
      {children}
    </div>
  )
}

export default TabGroups
